import { render } from "./exposureandadverseevents.vue?vue&type=template&id=0c6ad319&scoped=true"
import script from "./exposureandadverseevents.js?vue&type=script&lang=js"
export * from "./exposureandadverseevents.js?vue&type=script&lang=js"

import "./exposureandadverseevents.vue?vue&type=style&index=0&id=0c6ad319&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6ad319"]])

export default __exports__